module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 26.b34f00ca.png";